import React, {useState} from 'react';
import {Icon, Modal, Grid, Button} from 'semantic-ui-react';

const WtsCourseTechDetailsModal = () => {
  const [showModal, setShowModal] = useState(false);

  const showModalClick = (e, value) => {
    e.preventDefault();
    setShowModal(value);
  };

  return (
    <Modal
      open={showModal}
      trigger={
        <Icon
          name='info circle'
          size="big"
          color="blue"
          link
          onClick={(e) => showModalClick(e, true)}
        />
      }
    >
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            Detalles técnicos: Cursos Toyota
          </h2>
          <Icon
            className='download'
            name='close'
            style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showModalClick(e, false)}
          />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid celled>
          <Grid.Row>
            <Grid.Column width={2}><strong>Frontend</strong></Grid.Column>
            <Grid.Column width={14}>
              /src/wts/catalogs/courses
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>Backend (Base)</strong></Grid.Column>
            <Grid.Column width={14}>
              <div><strong>GET</strong>: /api/wts/courses/course (Obtener curso)</div>
              <div><strong>POST</strong>: /api/wts/courses/course</div>
              <div><strong>PUT</strong>: /api/wts/courses/course</div>
              <div><strong>DELETE</strong>: /api/wts/courses/course</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>Backend (ID)</strong></Grid.Column>
            <Grid.Column width={14}>
              <div><strong>GET</strong>: /api/wts/courses/course/&#123;courseId&#125;</div>
              <div><strong>POST</strong>: /api/wts/courses/course/&#123;courseId&#125;</div>
              <div><strong>PUT</strong>: /api/wts/courses/course/&#123;courseId&#125;</div>
              <div><strong>DELETE</strong>: /api/wts/courses/course/&#123;courseId&#125;</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>BDD</strong></Grid.Column>
            <Grid.Column width={14}>
              <div>TDE_CURSOS</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={2}><strong>Manual de usuario</strong></Grid.Column>
            <Grid.Column width={14}>
              <div style={{'display': 'flex', 'alignItems': 'center'}}>
                <a
                  href="https://scribehow.com/viewer/WTS__Modulo_de_cursos__nP-FlvJuRe-NgPd2T-EZdg"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{'marginRight': '20px'}}
                >
                  Cursos (Scribe - Externo)
                </a>
                <Button
                  as="a"
                  href="/media/docs/manualWTS.pdf"
                  download="manualWTS.pdf"
                  size="small"
                  color="blue"
                >
                  <Icon name="file pdf outline" /> Descargar PDF
                </Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

export default WtsCourseTechDetailsModal;
